import * as ptBR from './pt-BR';

export const locales = {
  'pt-BR': ptBR,
};
